<template>
  <div id="user-create-modal">
    <v-dialog v-model="modal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">新しいユーザーを作成する</span>
        </v-card-title>
        <v-card-text>
          <v-form refs="form" v-model="valid">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="ユーザー名"
                  v-model="form.username"
                  :rules="validation.username"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="パスワード"
                  type="password"
                  v-model="form.password"
                  :rules="validation.username"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="所属グループ名"
                  v-model="form.site_group"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('close')" text>閉じる</v-btn>
          <v-btn @click="$emit('submit', form)" text :disabled="!valid"
            >登録する</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "UserCreateModal",
  data() {
    return {
      form: { username: "", password: "", site_group: "" },
      valid: false,
      validation: {
        username: [
          (v) => !!v || "入力が必要な項目です。",
          (v) => (v && v.length >= 6) || "6文字以上が必要です。",
        ],
      },
    };
  },
  props: { modal: { Type: Boolean, default: () => false } },
};
</script>

<style></style>
